// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3UFz8","header":"styles_header__2Nfli","form":"styles_form__3jnKM","description":"styles_description__1bF3i"};